import BroadcastNotificationService from "@/services/broadcast_notification";

export default {
  namespaced: true,
  state: {},

  getters: {},

  actions: {
    async sendBroadcastNotification(
      { commit, state, getters, dispatch },
      payload
    ) {
      try {
        const response = await BroadcastNotificationService.sendBroadcastNotification(
          payload
        );

        return response;
      } catch (e) {
        console.log(e);
      }
    },
  },

  mutations: {},
};
